import axios from 'axios'

export async function newPet ({ commit }, formData) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Creando mascota'
  }, { root: true });
  return new Promise((resolve, reject) => {
    axios
      .post('/pets/', formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function modifyPetData ({ commit }, {formData, id}) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Modificando información'
  }, { root: true });
  return new Promise((resolve, reject) => {
    axios
      .patch(`/pets/${id}/`, formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function Unsuscribe({ commit }, pet) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Modificando información'
  }, { root: true });
  return new Promise((resolve, reject) => {
    axios
      .patch(`/pets/unsuscribepet/`,pet)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function getMyPets ({ commit }) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Cargando mis mascotas'
  }, { root: true });

  return new Promise((resolve, reject) => {
    axios
      .get('/pets/')
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function getPet ({ commit }, petId) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Cargando información de mascota'
  }, { root: true });

  return new Promise((resolve, reject) => {
    axios
      .get(`/pets/${petId}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function petCodes ({ commit }) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Cargando mis mascotas'
  }, { root: true });

  return new Promise((resolve, reject) => {
    axios
      .get('/pets-code/')
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

// eslint-disable-next-line
export async function getPetCode ({ commit }, {petCode}) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Obteniendo información de QR'
  }, { root: true });
  return new Promise((resolve, reject) => {
    axios
      .get(`/pets-code/${petCode}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

export async function setCodePet ({ commit }, {idPetCode, petId} ) {
  // Set loading page animation
  commit('setLoading', {
    isLoading: true,
    msg: 'Enlazando mascota'
  }, { root: true });

  return new Promise((resolve, reject) => {
    const petData = {
      pet: {
        id: petId
      }
    };
    axios
      .put(`/pets-code/${idPetCode}/`, petData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true });
        reject(error.response.data)
      })
      .finally(() => {
        commit('setLoading', { isLoading: false, msg: '' }, { root: true })
      })
  })
}

// eslint-disable-next-line
export async function setPetCoords({ commit }, data ) {

  return new Promise((resolve, reject) => {
    axios
      .post(`/pet-coords/`, data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

// eslint-disable-next-line
export async function removeLocationAction({ commit }, locationId ) {

  return new Promise((resolve, reject) => {
    axios
      .delete(`/pet-coords/${locationId}/`)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}


